/**
 * @typedef { import('../../objects/Payment').Payment } Payment
 */

export class CalculatedPayment {
    /**
     * @param {Payment} payment
     */
    constructor(payment) {
        this.payment = payment;
        this.chosenEmployer = null;
    }
}
